var Backbone = require('backbone');

var DocumentCollection = Backbone.Collection.extend({
  url: '/joinos/api/documents',
  parse(r){
    return r['results'];
  }
});

module.exports = DocumentCollection;



// WEBPACK FOOTER //
// ./base/collections/documents.js